import { EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import HELPERS from '../../lib/globals/helpers/Helpers';
class AutoSpinCheckBoxController {
	constructor(vc, conf) {
		this.vc = vc;
		this.config = conf;
		this.settings = GameConfigs.settings;
		if (this.vc[this.config.item]) {
			this.anim =
				this.vc[this.config.item].auto_spin_anim_cb.auto_spin_anim_checkbox;
			this.animText =
				this.vc[this.config.item].auto_spin_anim_cb.auto_spin_anim_text;
			this.fast =
				this.vc[this.config.item].auto_spin_fast_cb.auto_spin_fast_checkbox;
			this.fastText =
				this.vc[this.config.item].auto_spin_fast_cb.auto_spin_fast_text;
			this.anim.handler = this.update.bind(this);
			this.fastText.handler = this.update.bind(this);
			this.animText.handler = this.update.bind(this);
			this.fast.handler = this.update.bind(this);
			this.anim.setActive(!this.settings.game_animation);
			this.animText.setActive(!this.settings.game_animation);
			this.fast.setActive(this.settings.fast_spin);
			this.fastText.setActive(this.settings.fast_spin);
			this.init();
			window.addEventListener(EVENTS.MODAL, this, false);
			window.addEventListener(EVENTS.SETTINGS_UPDATE, this, false);
		} else {
			throw new Error(
				'AutoSpinCheckBoxController failed init ' + JSON.stringify(this.config)
			);
		}
	}

	handleEvent(evt) {
		switch (evt.type) {
			case EVENTS.MODAL:
				this.removeEvents();
				break;
			case EVENTS.SETTINGS_UPDATE:
				if (evt.detail.data.fast_spin === undefined) return;
				this.fast.setActive(evt.detail.data.fast_spin);
				this.fastText.setActive(evt.detail.data.fast_spin);
				this.fast.bg.alpha = this.fast.active ? 0 : 1;
				this.fast.fg.alpha = this.fast.active ? 1 : 0;
				break;
			default:
				break;
		}
	}

	removeEvents() {
		window.removeEventListener(EVENTS.MODAL, this, false);
		window.removeEventListener(EVENTS.SETTINGS_UPDATE, this, false);
	}
	init() {
		this.anim.bg.alpha = this.anim.active ? 0 : 1;
		this.anim.fg.alpha = this.anim.active ? 1 : 0;
		this.fast.bg.alpha = this.fast.active ? 0 : 1;
		this.fast.fg.alpha = this.fast.active ? 1 : 0;
	}
	update(e) {
		if (e === 'auto_spin_anim_checkbox' || e === 'auto_spin_anim_text') {
			this.anim.active = !this.anim.active;
			HELPERS.setSettings({
				game_animation: !this.anim.active
			});
		} else {
			this.fast.active = !this.fast.active;
			HELPERS.setSettings({
				fast_spin: this.fast.active
			});
		}
		this.init();
	}
}

export default AutoSpinCheckBoxController;
